var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"header-box"},[_c('img',{staticClass:"bg",attrs:{"src":_vm.dataSource.pcTopBackground}}),_vm._v(" "),_c('Swiper',{attrs:{"dataSource":_vm.dataSource.exp}})],1),_vm._v(" "),_vm._l((_vm.dataSource.detail),function(item,index){return _c('Detail',{key:index,attrs:{"dataSource":item}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }